import clsx from "clsx";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import classes from "./styles.module.scss";

import { Icon } from "@components/atoms/icons";
import { Input } from "@components/formControls";
import { Typography } from "@components/atoms/typography";
import type { IFilterProps } from "@components/molecules/filter/types";
import { FilterSelect } from "@components/molecules/filter/components/filterSelect";
import {
  clearAllFilters,
  normalizeFilterValues,
} from "@components/molecules/filter/helper";

export const Filter = memo(function Filter(props: IFilterProps) {
  const { options, value: rawValue, onFilterSelect, contentClassname } = props;

  const { t } = useTranslation("common");

  const value = useMemo(
    () => normalizeFilterValues(options, rawValue),
    [options, rawValue],
  );

  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger asChild>
        <div className={clsx(classes.filter__filterInput)}>
          <Input
            placeholder={t("filter")}
            icon={<Icon name={"AltArrowDown"} color={"primary-main"} />}
            className={clsx(classes.filter)}
            value={""}
          />
        </div>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          sideOffset={4}
          className={clsx(classes.filter__zIndex)}
        >
          <div className={clsx(classes.filter__inside, contentClassname)}>
            <div className={clsx(classes.filter__item, classes.filter__head)}>
              <Typography fontSize={"base"} fontWeight={"semi-bold"}>
                {t("filter")}
              </Typography>
              <Typography
                variant={"caption1"}
                color={"primary-main"}
                className={classes.filter__pointer}
                htmlAttribute={{
                  onClick: () => clearAllFilters(onFilterSelect),
                }}
              >
                {t("clearAll")}
              </Typography>
            </div>
            <div className={clsx(classes.filter__allItems)}>
              {options?.map((option, index) => (
                <FilterSelect
                  index={index}
                  content={option}
                  value={value}
                  options={options}
                  onFilterSelect={onFilterSelect}
                  key={option?.key}
                />
              ))}
            </div>
          </div>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
});
